import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Router from "@/routes/router";

export default function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="min-h-screen">
        <main><Router /></main>
        <Toaster position="top-right" toastOptions={{ duration: 5000 }} />
      </div>
    </BrowserRouter>
  );
}
